export enum SessionStorageEnum {
  AccessToken = 'access_token',
  SelectedCompany = 'selected_company',
  SelectedEmployee = 'selected_employee',
  ProjectInspectionData = 'project_inspection_data',
  GeneralData = 'general_data',
  ReferralUrl = 'referral_url'
}
